import React, { useEffect, useState } from 'react';
import { Form, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { loadOrganizations } from '../../../../../redux/asyncActions/reportSummaryDictionaries';
import { DropdownRender } from '../../../components/DropdownRender';

export const OrganizationSelect = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const organizations = useSelector((state) => state.reportSummaryDictionaries.organizations);
  const currentUser = useSelector((state) => state.currentUser);
  const form = Form.useFormInstance();
  const orgTypeIds = Form.useWatch('orgTypeIds', form);
  const organizationIds = Form.useWatch('organizationIds', form);
  const [isLoading, setIsLoading] = useState(false);

  const userOrganizations = currentUser.organizations || [];
  const source = userOrganizations.length > 0 ? userOrganizations : organizations;

  const options = source.map((item) => ({
    label: item.nameRu,
    value: item.id,
  }));

  const allIds = source.map((item) => item.id);

  const handleSelectAll = () => {
    const shouldSelectAll = !organizationIds || organizationIds.length !== allIds.length;
    form.setFieldsValue({ organizationIds: shouldSelectAll ? allIds : [] });
  };

  useEffect(() => {
    if (userOrganizations.length > 0) return;
    if (orgTypeIds !== undefined && (orgTypeIds || []).length > 0) {
      dispatch(loadOrganizations(orgTypeIds, setIsLoading));
    }
    form.setFieldsValue({ organizationIds: [] });
  }, [dispatch, orgTypeIds, form, userOrganizations.length]);

  const isDisabled =
    userOrganizations.length === 0 &&
    (orgTypeIds === undefined || orgTypeIds.length === 0 || organizations.length === 0 || isLoading);

  return (
    <Form.Item
      name='organizationIds'
      rules={[{ required: true, message: t('error.requiredField') }]}
    >
      <Select
        mode='multiple'
        maxTagCount='responsive'
        disabled={isDisabled}
        loading={isLoading}
        style={{ minWidth: 150 }}
        placeholder={t('governmentServiceEducation.organization')}
        options={options}
        filterOption={(input, option) =>
          option.label.toLowerCase().includes(input.toLowerCase())
        }
        optionFilterProp='label'
        dropdownRender={(menu) => (
          <DropdownRender
            menu={menu}
            handleSelectAll={handleSelectAll}
            formIds={organizationIds}
            dictionaryIds={allIds}
          />
        )}
      />
    </Form.Item>
  );
};
